module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/three-phase-panel/threePhasePanel.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/three-phase-panel/threePhasePanel.png
// module id = 640
// module chunks = 0